exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.location[data-v-6b52ce44]{padding:12px 0\n}\n.location i[data-v-6b52ce44]{display:inline-block;margin-right:12px\n}\n.location span[data-v-6b52ce44]{display:inline-block;margin:8px 0\n}\n.location-detail[data-v-6b52ce44]{display:block;width:100%;color:#fff\n}\n.location-detail .location-row[data-v-6b52ce44]{width:100%;display:inline-block;margin:4px 0\n}\n.small .location[data-v-6b52ce44]{padding:0\n}\n.small .zip-row[data-v-6b52ce44]{display:block;margin-top:0;width:100%\n}\n.small .small-info span[data-v-6b52ce44]{display:inline-block;margin-right:3px\n}\n.small .small-info .zip-row[data-v-6b52ce44]{width:initial\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b52ce44","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/trainer_detail_address/TrainerDetailAddress.vue
// module id = ip9F
// module chunks = 1